export default {
    data(){
        return {
            debounceTimer: null
        }
    },
    methods:{
        debounce(fn, wait=1000){
            return ((...args)=>{
                if(this.debounceTimer) {
                    clearTimeout(this.debounceTimer); // clear any pre-existing timer
                }
                //  const context = this; // get the current context
                this.debounceTimer = setTimeout(()=>{
                    fn(...args); // call the function if time expires
                }, wait);
            })()
        }
   }
}